<div class="c-global-message" *ngIf="globalNotificationMessage$|async as message">{{message}}</div>
<div class="c-global-message" *ngIf="orgNotificationMessage$|async as message">{{message}}</div>

